export default "__VITE_ASSET__b09c4e7a__"